import Vue from "vue";
import Router from "vue-router";
import appConfig from "../../src/app.config";
import { api } from "@/state/services";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: () => import("./views/home"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/login",
      component: () => import("./views/login"),
      meta: {
        title: appConfig.title,
        authRequired: false,
        keepAlive: false,
      },
    },
    {
      path: "/login/token/:token",
      component: () => import("./views/login-in"),
      meta: {
        title: appConfig.title,
        authRequired: false,
        keepAlive: false,
      },
    },
    {
      path: "/logout",
      redirect: "/login",
    },
    {
      path: "/register",
      component: () => import("./views/register"),
      meta: {
        title: appConfig.title,
        authRequired: false,
        keepAlive: false,
      },
    },
    {
      path: "/register/:sponsor",
      component: () => import("./views/register"),
      meta: {
        title: appConfig.title,
        authRequired: false,
        keepAlive: false,
      },
    },
    {
      path: "/password-forgot",
      component: () => import("./views/password-forgot"),
      meta: {
        title: appConfig.title,
        authRequired: false,
        keepAlive: false,
      },
    },
    {
      path: "/password-change",
      component: () => import("./views/password-change"),
      meta: {
        title: appConfig.title,
        authRequired: false,
        keepAlive: false,
      },
    },
    {
      path: "/upgrade",
      component: () => import("./views/upgrade"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/account",
      component: () => import("./views/account/account"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/account/membership",
      component: () => import("./views/account/membership"),
      meta: {
        title: appConfig.title,
        authRequired: true,
      },
    },
    {
      path: "/account/documents",
      component: () => import("./views/account/documents"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/account/address",
      component: () => import("./views/account/address"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/account/password",
      component: () => import("./views/account/password"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/account/password/security",
      component: () => import("./views/account/password-security"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/account/password/security/:token",
      component: () => import("./views/account/password-security"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/account/pix",
      component: () => import("./views/account/pix"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/contracts",
      component: () => import("./views/contracts/list"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/contracts/:id",
      component: () => import("./views/contracts/view"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/wallet/extract",
      component: () => import("./views/wallet/extract-network"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/wallet/transfer",
      component: () => import("./views/wallet/transfer"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/wallet/pay",
      component: () => import("./views/wallet/pay"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/wallet/pay/:id",
      component: () => import("./views/wallet/pay"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/wallet/withdrawal",
      component: () => import("./views/wallet/withdrawal"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/wallet/withdrawal/history",
      component: () => import("./views/wallet/withdrawal-history"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/network/clients",
      component: () => import("./views/network/clients"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/network/sponsored",
      component: () => import("./views/network/sponsored"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/network/team",
      component: () => import("./views/network/team"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/network/matriz",
      component: () => import("./views/network/matriz"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/network/unilevel",
      component: () => import("./views/network/unilevel"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/network/unilevel/:id",
      component: () => import("./views/network/unilevel"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/reports/indicacao",
      component: () => import("./views/reports/indicacao"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/reports/clube",
      component: () => import("./views/reports/clube"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/reports/lider",
      component: () => import("./views/reports/lider"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/reports/ecommerce",
      component: () => import("./views/reports/ecommerce"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/reports/graduation",
      component: () => import("./views/reports/graduation"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/store",
      redirect: "/store/featured",
    },
    {
      path: "/store/featured",
      component: () => import("./views/store/featured"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/store/category/:id",
      component: () => import("./views/store/category"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/store/search",
      component: () => import("./views/store/search"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/store/cart",
      component: () => import("./views/store/cart"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/store/orders",
      component: () => import("./views/store/orders"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/store/order/:id",
      component: () => import("./views/store/order"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/store/franchises",
      component: () => import("./views/store/franchises"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/downloads",
      component: () => import("./views/downloads"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/faq",
      component: () => import("./views/faq"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/tickets",
      component: () => import("./views/tickets"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/tickets/:id",
      component: () => import("./views/tickets-view"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/franchise",
      component: () => import("./views/franchise/home"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/franchise/register",
      component: () => import("./views/franchise/register"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/franchise/account",
      component: () => import("./views/franchise/account"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/franchise/reports",
      component: () => import("./views/franchise/reports"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/franchise/orders",
      component: () => import("./views/franchise/orders"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/franchise/orders/:id",
      component: () => import("./views/franchise/order"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/franchise/store/cart",
      component: () => import("./views/franchise/store-cart"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/franchise/points/extract",
      component: () => import("./views/franchise/points-extract"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/franchise/points/orders",
      component: () => import("./views/franchise/points-orders"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/franchise/points/orders/:id",
      component: () => import("./views/franchise/points-order"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/franchise/points/cart",
      component: () => import("./views/franchise/points-cart"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/franchise/inventory",
      component: () => import("./views/franchise/inventory"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/franchise/inventory/restock",
      component: () => import("./views/franchise/inventory-restock"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/franchise/inventory/orders",
      component: () => import("./views/franchise/inventory-orders"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/franchise/inventory/orders/:id",
      component: () => import("./views/franchise/inventory-order"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/franchise/wallet/extract",
      component: () => import("./views/franchise/wallet-extract"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/franchise/wallet/transfer",
      component: () => import("./views/franchise/wallet-transfer"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/franchise/wallet/withdrawal",
      component: () => import("./views/franchise/wallet-withdrawal"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/franchise/wallet/withdrawal/history",
      component: () => import("./views/franchise/wallet-withdrawal-history"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/courses",
      component: () => import("./views/courses/list"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/courses/:course",
      component: () => import("./views/courses/view"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/courses/:course/:module/:lesson",
      component: () => import("./views/courses/view"),
      meta: {
        title: appConfig.title,
        authRequired: true,
        keepAlive: false,
      },
    },
    {
      path: "/404",
      component: () => import("./views/404"),
      meta: {
        title: appConfig.title,
        authRequired: false,
        keepAlive: false,
      },
    },
    {
      path: "*",
      redirect: "/register*",
    },
  ],
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem("token");

  if (to.meta.authRequired && !loggedIn) {
    return next("/login");
  }

  if (to.meta.authRequired && loggedIn) {
    api
      .get("user")
      .then((response) => {
        if (response.data && response.data.status == "success") {
          if (
            response.data.user.contracts &&
            response.data.user.contracts.length > 0
          ) {
            response.data.user.contracts.forEach(con => {
              if (to.path != "/contracts/" + con.id) {
                return next("/contracts/" + con.id);
              }
            })
          }
        } else {
          return next("/login");
        }
      })
      .catch(error => {
        if (error) {
          return next("/login");
        }
      });
  }

  document.title = to.meta.title;
  next();
});

export default router;
